import { render, staticRenderFns } from "./KnDownloadDocItem.vue?vue&type=template&id=6cd1815b&scoped=true"
import script from "./KnDownloadDocItem.vue?vue&type=script&lang=js"
export * from "./KnDownloadDocItem.vue?vue&type=script&lang=js"
import style0 from "./KnDownloadDocItem.vue?vue&type=style&index=0&id=6cd1815b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6cd1815b",
  null
  
)

export default component.exports